// extracted by mini-css-extract-plugin
export default {"container":"LoginPage_container__ZSt43","left":"LoginPage_left__yJodP","google-login-wrapper":"LoginPage_google-login-wrapper__V9+ey","right":"LoginPage_right__rwToY"};